import { z } from 'zod';
import { capitalize } from '../../utils/capitalize.js';
import { optionalNullableLocalDateInput, optionalTrimmedNullableString, requiredUuidString, } from '../zod-helpers/index.js';
import { CUSTOMER_LICENSE_CONSTRAINTS as LIMITS } from './constraints.js';
import { LICENSE_DATE_ORDER_MESSAGE } from './license-date-order-message.js';
import { licenseDatesInOrder } from './license-dates-in-order.js';
export const createCustomerLicenseInputSchema = z
    .object({
    licenseNumber: z
        .string()
        .trim()
        .min(1, `${capitalize(LIMITS.licenseNumber.label.toLowerCase())} is required.`)
        .max(LIMITS.licenseNumber.maxLength),
    licenseType: optionalTrimmedNullableString(LIMITS.licenseType.maxLength),
    stateId: requiredUuidString(`${capitalize(LIMITS.stateId.label.toLowerCase())} is required.`, 'Invalid state.'),
    issuedAt: optionalNullableLocalDateInput('Invalid date.'),
    expiresAt: optionalNullableLocalDateInput('Invalid date.'),
})
    .refine(licenseDatesInOrder, { path: ['expiresAt'], message: LICENSE_DATE_ORDER_MESSAGE });
//# sourceMappingURL=create-input.js.map